module.exports = __webpack_public_path__ + "static/media/14UNEP22.fead3d93.jpg";